import React from 'react'
import PropTypes from 'prop-types'
import { NavLink, withRouter } from 'react-router-dom'

import Modal from 'components/Modal'
import Button from 'components/buttons/Button'
import SectionWithHeader from 'layout/SectionWithHeader'

import { AddDivisionForm, EditDivisionForm, DeleteDivisionForm } from 'forms/Division'
import DivisionsList from 'lists/DivisionsList'

import { AddManagerForm, EditManagerForm, DeleteManagerForm } from 'forms/Manager'
import ManagersList from 'lists/ManagersList'

import { AddLeaveForm, EditLeaveForm, DeleteLeaveForm } from 'forms/Leave'
import LeavesList from 'lists/LeavesList'

import { AddAdminForm, EditAdminForm, DeleteAdminForm } from 'forms/Admin'
import AdminsList from 'lists/AdminsList'

import UsersAPI from 'api/UsersAPI'
import DivisionsAPI from 'api/DivisionsAPI'
import LeavesAPI from 'api/LeavesAPI'

import styles from './index.css'

@withRouter
export default class Settings extends React.Component {
  
  static propTypes = {
  }

  state = {
    modal : null,
    entityId : null,

    divisions: [],
    managers: [],
    leaves: [],
    admins : [],
  }

  constructor(props) {
    super(props)
    this.fetchAdmins = this.fetchAdmins.bind(this)
    this.fetchManagers = this.fetchManagers.bind(this)
    this.fetchLeaves = this.fetchLeaves.bind(this)
    this.fetchDivisions = this.fetchDivisions.bind(this)
  }

  async fetchAdmins() {
    this.setState({ loadingAdmins: true })
    const {response} = await UsersAPI.listAdmins()
    if (response) this.setState({ admins: response.results })
    this.setState({ loadingAdmins: false })
  }

  async fetchManagers() {
    this.setState({ loadingManagers: true })
    const {response} = await UsersAPI.listManagers()
    if (response) this.setState({ managers: response.results })
    this.setState({ loadingManagers: false })
  }

  async fetchLeaves() {
    this.setState({ loadingLeaves: true })
    const {response} = await LeavesAPI.list()
    if (response) this.setState({ leaves: response })
    this.setState({ loadingLeaves: false })
  }

  async fetchDivisions() {
    this.setState({ loadingDivisions: true })
    const {response} = await DivisionsAPI.list()
    if (response) this.setState({ divisions: response })
    this.setState({ loadingDivisions: false })
  }

  componentDidMount() {
    this.fetchAdmins()
    this.fetchManagers()
    this.fetchLeaves()
    this.fetchDivisions()
  }

  render() {
        
    const { admins } = this.state
    
    return (
      <div className={styles.Page}>

        <Modal open={'DIVISION_ADD' == this.state.modal}>
          <AddDivisionForm 
            onClose={() => this.setState({ modal : null })} 
            onSubmitted={this.fetchDivisions}
            />
        </Modal>

        <Modal open={'DIVISION_EDIT' == this.state.modal}>
          <EditDivisionForm 
            id={this.state.entityId}
            onClose={() => this.setState({ modal : null })} 
            onSubmitted={this.fetchDivisions}/>
        </Modal>

        <Modal open={'DIVISION_DELETE' == this.state.modal}>
          <DeleteDivisionForm 
            id={this.state.entityId}
            onClose={() => this.setState({ modal : null })} 
            onSubmitted={this.fetchDivisions}/>
        </Modal>
        
        <SectionWithHeader
          title={"Divisions"}
          headerChildren={
            <Button
              fullWidth={false}
              onClick={() => this.setState({ modal: 'DIVISION_ADD' })}>
              Add Division
            </Button>
          }>
          <DivisionsList 
            loading={this.state.loadingDivisions}
            entities={this.state.divisions}
            onEdit={id => this.setState({ modal: 'DIVISION_EDIT', entityId: id })}
            onDelete={id => this.setState({ modal: 'DIVISION_DELETE', entityId: id })}
            />
        </SectionWithHeader>



        <Modal open={'MANAGER_ADD' == this.state.modal}>
          <AddManagerForm 
           onClose={() => this.setState({ modal : null })} 
           onSubmitted={() => {
            this.fetchManagers()
            this.fetchDivisions()
          }}
           />
        </Modal>
        
        <Modal open={'MANAGER_EDIT' == this.state.modal}>
          <EditManagerForm 
            id={this.state.entityId}
            onClose={() => this.setState({ modal : null })} 
            onSubmitted={() => {
              this.fetchManagers()
              this.fetchDivisions()
            }}
            />
        </Modal>

        <Modal open={'MANAGER_DELETE' == this.state.modal}>
          <DeleteManagerForm 
            id={this.state.entityId}
            onClose={() => this.setState({ modal : null })} 
            onSubmitted={() => {
              this.fetchManagers()
              this.fetchDivisions()
            }}
            />
        </Modal>

        <br/><br/>

        <SectionWithHeader
          title={"Managers"}
          headerChildren={
            <Button
              fullWidth={false}
              onClick={() => this.setState({ modal: 'MANAGER_ADD' })}>
              Add Manager
            </Button>
          }>
          <ManagersList 
            loading={this.state.loadingManagers}
            entities={this.state.managers} 
            onEdit={id => this.setState({ modal: 'MANAGER_EDIT', entityId: id })}
            onDelete={id => this.setState({ modal: 'MANAGER_DELETE', entityId: id })}
            />
        </SectionWithHeader>



        <Modal open={'LEAVE_ADD' == this.state.modal}>
          <AddLeaveForm 
            onClose={() => this.setState({ modal : null })} 
            onSubmitted={this.fetchLeaves}
            />
        </Modal>
        
        <Modal open={'LEAVE_EDIT' == this.state.modal}>
          <EditLeaveForm 
            id={this.state.entityId}
            onClose={() => this.setState({ modal : null })} 
            onSubmitted={this.fetchLeaves}
            />
        </Modal>

        <Modal open={'LEAVE_DELETE' == this.state.modal}>
          <DeleteLeaveForm 
            id={this.state.entityId}
            onClose={() => this.setState({ modal : null })} 
            onSubmitted={this.fetchLeaves}
            />
        </Modal>

        <br/><br/>

        <SectionWithHeader
          title={"Leave"}
          headerChildren={
            <Button
              fullWidth={false}
              onClick={() => this.setState({ modal: 'LEAVE_ADD' })}>
              Add Leave
            </Button>
          }>
          <LeavesList 
            loading={this.state.loadingLeaves}
            entities={this.state.leaves} 
            onEdit={id => this.setState({ modal: 'LEAVE_EDIT', entityId: id })}
            onDelete={id => this.setState({ modal: 'LEAVE_DELETE', entityId: id })}
            />
        </SectionWithHeader>

        <Modal open={'ADMIN_ADD' == this.state.modal}>
          <AddAdminForm 
            onClose={() => this.setState({ modal : null })} 
            onSubmitted={this.fetchAdmins}
            />
        </Modal>
        
        <Modal open={'ADMIN_EDIT' == this.state.modal}>
          <EditAdminForm 
            id={this.state.entityId}
            onClose={() => this.setState({ modal : null })} 
            onSubmitted={this.fetchAdmins}
            />
        </Modal>

        <Modal open={'ADMIN_DELETE' == this.state.modal}>
          <DeleteAdminForm 
            id={this.state.entityId}
            onClose={() => this.setState({ modal : null })} 
            onSubmitted={this.fetchAdmins}
            />
        </Modal>

        <br/><br/>

        <SectionWithHeader
          title={"Admins"}
          headerChildren={
            <Button
              fullWidth={false}
              onClick={() => this.setState({ modal: 'ADMIN_ADD' })}>
              Add Admin
            </Button>
          }>
          <AdminsList 
            loading={this.state.loadingAdmins}
            entities={admins} 
            onEdit={id => this.setState({ modal: 'ADMIN_EDIT', entityId: id })}
            onDelete={id => this.setState({ modal: 'ADMIN_DELETE', entityId: id })}
            />
        </SectionWithHeader> 
      </div>
    )
  }

}



// WEBPACK FOOTER //
// ./src/pages/Settings/index.jsx